<div class="d-flex flex-column gap-2">
  <div class="review-entry-label">{{ relationshipStatus.typeId | relationshipStatusEffectiveDateLabel }}</div>
  <div class="d-flex gap-2 align-items-center">
    <div class="review-entry-value flex-grow-1">
      {{ relationshipStatus?.effectiveDate | date : 'MMM d, y' }}
    </div>
    <img
      *ngIf="relationshipStatus.typeId === RelationshipStatus.CommonLaw"
      class="tooltip-icon"
      [src]="'assets/icons/dark/Question Circle.svg'"
      [ngbTooltip]="tooltipText"
      alt=""
      height="24"
      width="24" />
  </div>
  <hr class="m-0" />
</div>
